import React from 'react';

export const LoadingScreen = () => {
    return (
        <>
            <div
                className="expire-block text-center"
                data-testid="loading-screen"
            >
                <div className="custom-width">
                    <img
                        src={process.env.PUBLIC_URL + '/loader.gif'}
                        alt="Loading..."
                    />
                </div>
            </div>
        </>
    );
};
